import { jsx as _jsx } from "react/jsx-runtime";
import { Analytics } from '../../../helpers/analyticsMiddleware';
import { shallowEqual, useSelector } from 'react-redux';
import { ButtonType } from '../../../redux/ui/typings';
import { t } from '../../../strings/i18n/i18n';
import { CustomModalFooter } from '../../../ui/patterns/SlideinModal/subcomponents';
var getPrimaryDataReason = function (additionalInfoEnabled) {
    if (additionalInfoEnabled) {
        return null;
    }
    return 'Close';
};
var getSecondaryDataAnalytics = function (eligibleForCancel, isRedispute) {
    var secondaryDataAnalytics = {
        dataType: Analytics.DisputeTransaction,
        dataReason: ''
    };
    if (isRedispute) {
        secondaryDataAnalytics.dataReason = Analytics.RedisputeTransaction;
        secondaryDataAnalytics.dataType = Analytics.Footer;
    }
    if (eligibleForCancel) {
        secondaryDataAnalytics.dataReason = Analytics.CancelThisDispute;
    }
    return secondaryDataAnalytics;
};
var primaryButtonText = function (additionalInfoEnabled, eligibleForUploads) {
    var buttonText = '';
    if (additionalInfoEnabled && eligibleForUploads) {
        buttonText = t('button.additionalInfo');
    }
    else {
        buttonText = t('button.close');
    }
    return buttonText;
};
var secondaryButtonText = function (eligibleForCancel, eligibleForRedispute) {
    var buttonText = null;
    if (eligibleForCancel) {
        buttonText = t('disputeInfo.cancelThisDispute');
    }
    else if (eligibleForRedispute) {
        buttonText = t('disputeInfo.redispute');
    }
    return buttonText;
};
var secondaryButtonType = function (eligibleForCancel, eligibleForRedispute) {
    var buttonType = ButtonType.Primary;
    if (eligibleForCancel) {
        buttonType = ButtonType.TextDestroy;
    }
    else if (eligibleForRedispute) {
        buttonType = ButtonType.Ghost;
    }
    return buttonType;
};
var DisputeInfoModalFooter = function (_a) {
    var additionalInfoEnabled = _a.additionalInfoEnabled, eligibleForCancel = _a.eligibleForCancel, eligibleForRedispute = _a.eligibleForRedispute, eligibleForUploads = _a.eligibleForUploads, handleUploadDocuments = _a.handleUploadDocuments, fireCloseModal = _a.fireCloseModal, onCancelDispute = _a.onCancelDispute, handleRedispute = _a.handleRedispute;
    var redispute = useSelector(function (state) { return state; }, shallowEqual).featureFlags.redispute;
    var isRedispute = redispute && eligibleForRedispute;
    var primaryDataReason = getPrimaryDataReason(additionalInfoEnabled);
    var _b = getSecondaryDataAnalytics(eligibleForCancel, isRedispute), dataSecondaryType = _b.dataType, dataSecondaryReason = _b.dataReason;
    var primaryFooterText = primaryButtonText(additionalInfoEnabled, eligibleForUploads);
    var secondaryFooterText = secondaryButtonText(eligibleForCancel, eligibleForRedispute);
    var secondaryFooterType = secondaryButtonType(eligibleForCancel, eligibleForRedispute);
    var shouldHandleSecondaryClick = eligibleForCancel || (redispute && eligibleForRedispute);
    var handleSecondaryClick = function () {
        if (eligibleForCancel) {
            onCancelDispute();
        }
        if (isRedispute) {
            handleRedispute();
        }
    };
    var primaryDataType = additionalInfoEnabled
        ? "add doc's or comments"
        : 'dispute-transaction';
    return (_jsx(CustomModalFooter, { dataCy: "dispute-info-modal", dataPrimaryObject: "button", dataPrimaryReason: primaryDataReason, dataPrimaryTitle: additionalInfoEnabled ? null : 'dispute-transaction', dataPrimaryType: primaryDataType, dataSecondaryObject: "button", dataSecondaryReason: dataSecondaryReason, dataSecondaryTitle: "dispute-transaction", dataSecondaryType: dataSecondaryType, handlePrimaryButton: additionalInfoEnabled && eligibleForUploads
            ? handleUploadDocuments
            : fireCloseModal, handleSecondaryButton: shouldHandleSecondaryClick && handleSecondaryClick, primaryText: primaryFooterText, secondaryButtonType: secondaryFooterType, secondaryText: secondaryFooterText }));
};
export default DisputeInfoModalFooter;
//# sourceMappingURL=index.js.map